import axios from 'axios'
import { CALL_API } from 'tr-components/redux/CallApiMiddlewareActionCreator'

export const actions = {
  FETCH_LOCATION_DEPARTMENTS: 'positions/FETCH_LOCATION_DEPARTMENTS',
  FETCH_LOCATION_DEPARTMENTS_SUCCESS: 'positions/FETCH_LOCATION_DEPARTMENTS_SUCCESS',
  FETCH_LOCATION_DEPARTMENTS_FAIL: 'positions/FETCH_LOCATION_DEPARTMENTS_FAIL'
}
export const initialState = {
  fetchingLocationDepartments: false,
  locationDepartments: [
    {
      location: {
        id: 1,
        name: 'Denver',
        propertyNumber: 1001
      },
      department: {
        id: 10,
        name: 'Sales'
      }
    },
    {
      location: {
        id: 2,
        name: 'Boulder',
        propertyNumber: 1002
      },
      department: {
        id: 11,
        name: 'Marketing'
      }
    },
    {
      location: {
        id: 3,
        name: 'Aurora',
        propertyNumber: 1003
      },
      department: {
        id: 13,
        name: 'Service'
      }
    }
  ],
  error: null
}
const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.FETCH_LOCATION_DEPARTMENTS:
      return {
        ...state,
        fetchingLocationDepartments: true,
        error: null
      }
    case actions.FETCH_LOCATION_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        locationDepartments: payload,
        fetchingLocationDepartments: false
      }
    case actions.FETCH_LOCATION_DEPARTMENTS_FAIL:
      return {
        ...state,
        fetchingLocationDepartments: false,
        error: payload
      }
    default:
      return state
  }
}

export default reducer

export const fetchLocationDepartments = () => ({
  type: CALL_API,
  types: [
    actions.FETCH_LOCATION_DEPARTMENTS,
    actions.FETCH_LOCATION_DEPARTMENTS_SUCCESS,
    actions.FETCH_LOCATION_DEPARTMENTS_FAIL
  ],
  callAPI: () => axios.get('/locationdepartments')
})



// WEBPACK FOOTER //
// ./src/modules/Positions/reducers/locationDepartment.js